import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import icons from '../../../helpers/Icons';
import { TOGGLE_SORT } from '../../../redux/Table';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

class TableHeaderCellContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.debouncedFetchOffers = debounce(props.fetchOffers, 600);
  }
  getSortIcon = (order) => {
    switch (order) {
      case 'asc':
        return icons('arrow_drop_asc');
      case 'desc':
        return icons('arrow_drop_desc');
      default:
        return null;
    }
  };
  handleToggleSort = () => {
    const { tableName, label, toggleSort, isSortable } = this.props;
    if (isSortable) {
      toggleSort({ tableName, sortBy: label });
      this.debouncedFetchOffers();
    }
  };

  render() {
    const { tableName, label, sortBy, order, isSortable, t } = this.props;
    const sortOrderIcon = this.getSortIcon(order);
    const translation = t(label) || t(`${tableName}.${label}`);
    const shouldShowSortingIcon = sortBy === label;
    const cellClassNames = classNames(`cell-${label}`, { sortable: isSortable });

    return (
      <th className={cellClassNames} onClick={this.handleToggleSort}>
        <div className="table-head-cell">
          <span>{translation}</span>
          {shouldShowSortingIcon && sortOrderIcon}
        </div>
      </th>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    sortBy: get(state, ['tables', ownProps.tableName, 'sort', 'sortBy']),
    order: get(state, ['tables', ownProps.tableName, 'sort', 'order']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return { toggleSort: payload => dispatch(TOGGLE_SORT(payload)) };
};

TableHeaderCellContainer.propTypes = {
  t: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  toggleSort: PropTypes.func.isRequired,
  fetchOffers: PropTypes.func.isRequired,
  tableName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  sortBy: PropTypes.string,
  order: PropTypes.string,
  isSortable: PropTypes.bool,
};

TableHeaderCellContainer.defaultProps = {
  sortBy: null,
  order: null,
  isSortable: true,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('tables'),
  )(TableHeaderCellContainer);
